import { Component, OnInit } from '@angular/core';
import {InputrendererComponent} from '../inputrenderer/inputrenderer.component';
import {LoginService} from '../login.service';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { Router,RouterModule} from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { ServerConstantsService } from '../serverConstants.service';

@Component({
  selector: 'app-trackcomponent',
  templateUrl: './trackcomponent.component.html',
  styleUrls: ['./trackcomponent.component.css']
})
export class TrackcomponentComponent implements OnInit {
  private gridApi;
  private gridColumnApi;
  public context;
  public frameworkComponents;
  defaultColDef = { resizable: true, cellStyle:{'font-size':'14px'} };
  columnDefs = [];
  monthDropdown:any=[];
  selectedMonth:any;
  rowData = [];
  viewOnly:Boolean = false;
  totalHours:any = 0;
  verified:Boolean = false;
  update:Boolean = false;
  required:Boolean = false;
  totalReportedhours:any=0;
  reasontype:any = null;

  constructor(public loginService:LoginService,public toastService:ToastrService, public router:Router) {
    let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
    if(sessionStorage.getItem('track') != undefined && CryptoJS.AES.decrypt(sessionStorage.getItem('track'), key).toString(CryptoJS.enc.Utf8) != 'true'){
      this.router.navigate(['dashboard']);
    }
   }

  ngOnInit() {
    this.columnDefs = [{headerName: 'Month', field: 'month' },
    {headerName: 'Activity', field: 'component' },
    {headerName: 'Required Hours', field: 'authorized_hours'},
    {headerName: 'Reported Hours', field: 'reported_hours',cellRenderer:'inputrenderer'},
    {headerName: 'Verified Hours', field: 'completed_hours'}];
    this.context = {
      componentParent:this
    };
    this.frameworkComponents = {
      inputrenderer: InputrendererComponent
    };
    let monthName = new Array("January","February","March","April","May","June","July","August","September","October","November","December");
    let d = new Date();
    for(let i=0;i<=24;i++){
      this.monthDropdown.push(monthName[d.getMonth()]+' '+d.getFullYear());
      d.setMonth(d.getMonth()-1);
    }
    this.selectedMonth = this.monthDropdown[0];
    this.loadSummary();
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    //this.gridApi.setDomLayout("autoHeight");
  }
  getreported(params){
    const box = document.createElement("input");
    return box;
  }
  loadSummary(){
    this.viewOnly = false;
    this.reasontype = null;
    if(this.selectedMonth == this.monthDropdown[0] || this.selectedMonth == this.monthDropdown[1]){
      this.viewOnly = false;
    }
    else{
      this.viewOnly = true;
    }
    let monthName = new Array("January","February","March","April","May","June","July","August","September","October","November","December");
    let splitValue = this.selectedMonth.split(' ');
    let request = {
      month:(monthName.indexOf(splitValue[0])+1) +'/'+ splitValue[1],
      personId:this.loginService.personId
    }
    if(request.month.length == 6){
      request.month = 0+request.month;
    }
    this.loginService.componentSummary(request).subscribe((data)=>{
      data[0].forEach((element)=>{
        element['month'] = element['month'].split('-')[1] + '/' + element['month'].split('-')[0];
        element['component'] = this.loginService.staticData.get("COMPONENTS").find(obj => obj.value == element['component_cd']).name;
        if(element['completed_hours'] == null){
          element['credHours'] = null;
        }
        else{
          element['credHours'] = (parseFloat(this.loginService.staticData.get("CountableHoursDesc").find(obj => obj.value == element['component_cd']).name) * element['completed_hours']);
          this.verified = true;
        }
        if(this.viewOnly == true){
          element['fin_sw'] = 'Y';
        }
      })
      if(data[1].length > 0){
        if(this.loginService.staticData.get("NonCompReasonDesc").find(obj => obj.value == data[1][0]['non_compliance_reason_cd'])){
          this.reasontype = 'Good Cause';
        }
        else{
          this.reasontype = 'Exemption';
        }
      }
      this.rowData = data[0];
      this.totalHours = 0;
      this.totalReportedhours = 0;
      let count =0;
      this.rowData.forEach((element)=>{
        this.totalHours = this.totalHours + element.completed_hours;
        this.totalReportedhours = this.totalReportedhours + element.reported_hours;
        if(element.fin_sw == 'Y'){
          count = count +1;
        }
      });
      if((count != 0) && (count == this.rowData.length)){
        this.viewOnly = true;
      }
      if(this.rowData.length == 0 && this.update){
        $('#message').click();
      }
      this.update = false;
    },error=>{
      this.toastService.error("Unable to load component summary","Track Component");
    })
  }
  updateHours(){
    this.update = true;
    this.loginService.updateHours().subscribe((data)=>{
      if(data["message"] == 'success'){
        this.loadSummary();
      }
      else{
        this.toastService.error("Record not saved: Please review or contact Help Desk","Track Component");
      }
    },error=>{
      this.toastService.error("Record not saved: Please review or contact Help Desk","Track Component");
    });
  }
  save(){
    this.required = false;
    let request = [];
    this.rowData.forEach((element)=>{
      if(element.reported_hours == undefined){
        this.required = true;
      }
      else{
        request.push(element);
      }
      if(request.length > 0){
        this.saveSubmit(request);
      }
    })
  }
    saveSubmit(request){
    this.loginService.saveComponent(request).subscribe((data)=>{
      if(data["message"] == 'success'){
        this.toastService.success("Updated hours successfully","Track Component");
      }
      else{
        this.toastService.error("Record not saved: Please review or contact Help Desk","Track Component");
      }
    },error=>{
      this.toastService.error("Record not saved: Please review or contact Help Desk","Track Component");
    })
  }
  finalize(){
    this.rowData.forEach((element)=>{
      element.fin_sw = 'Y';
      element.dueDt=this.loginService.staticData.get("TASKDUEDATES").find(obj => obj.value == 'CH').name;
      element.perId = this.loginService.personId;
    })
    this.loginService.saveComponent(this.rowData).subscribe((data)=>{
      $("#closeConfirm").click();
      if(data["message"] == 'success'){
        this.toastService.success("Submitted hours successfully","Track Component");
        this.viewOnly = true;
        this.loadSummary();
      }
      else{
        this.toastService.error("Record not saved: Please review or contact Help Desk","Track Component");
      }
    },error=>{
      this.toastService.error("Record not saved: Please review or contact Help Desk","Track Component");
    })
  }
  focus(event){
    if(this.reasontype !== null){
      return;
    }
    else{
      this.focus1(event);
    }
  }
  focus1(event){
    if(event.keyCode == 9){
      this.gridApi.ensureIndexVisible(0);
      let firstCol = this.gridColumnApi.getAllDisplayedColumns()[0];
      this.gridApi.ensureColumnVisible(firstCol);
      if(firstCol.gridOptionsWrapper.gridOptions.rowData.length == 0){
        return;
      }
      else{
        event.preventDefault();
        this.gridApi.setFocusedCell(0, firstCol);
      }
    }
    else{
      return;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/trackcomponent/trackcomponent.component.ts